import React, { Component } from "react";
import logo from "views/stepPortal/image/login/logo.png";
import steplogo from "views/stepPortal/image/login/steplogo.png";
class Left extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="h-full px-32 py-16">
        <div className="px-4">
          <div className="flex items-center justify-between px-4">
            <img src={logo} alt="logo" className="icici-logo-w" />
            <p className="divider-vertical"></p>
            <img src={steplogo} alt="logo" className="step-logo-w" />
          </div>

          <div className="mt-16">
            <h2 className="fsize20 font-bold text-black">Proceed to Test</h2>
            <div className="mt-4">
              <form action="" className="">
                <div className="form-group pt-6 modal-form-cs">
                  <label for="">Mobile Number*</label>
                  <input type="text" placeholder="" value="9123456781" />
                </div>

                <div className="form-group pt-6 modal-form-cs">
                  <label for="">Email*</label>
                  <input type="text" placeholder="" value="info@gmail.com" />
                </div>
                <p className="fsize14 text-black mt-8">
                  By clicking <span className="font-semibold">“submit”</span>
                  button, ICICI Bank is authorized to send you WhatsApp
                  notification for future updates.
                </p>
                <div className="flex justify-center mt-20">
                  <button className="fsize16  rounded-7px font-bold text-white login-submit-btn">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Left;
